<header>
    <!-- <img src="./assets/login-header.jpg" style="width: 100%;"> -->
    <div class="row">
        <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
            <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
            <!-- <a href="https://rashtragaan.in/">         
                <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
            </a>
            <img src="./../../../assets/logoembdig.png" alt="Dental Council of India" title="Dental Council of India"> -->
        <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
        </div>
    </div>
    <div class="container h-100">
        <div class="align-items-center">
            <div>
                <div class="global-container">
                    <div class="card login-form">
                        <div class="card-body">
                            <div class="card-text">
                                <h3 class="headerStyles">Authenticate</h3>
                                <div class="row">
                                    <div class="col-md-12">
                                        <form [formGroup]="uidrCertForm">
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <input type="text" class="form-control"  maxlength="100"  formControlName="emailId" placeholder="Email Id" [ngClass]="{ 'is-invalid':  submitted && f.emailId.errors }">

                                                    <div *ngIf=" submitted && f.emailId.errors" class="invalid-feedback">
                                                        <div *ngIf=" submitted && f.emailId.errors.required">Email Id {{errorMsgs.required}}</div>
                                                        <div *ngIf=" submitted && f.emailId.errors.email">{{errorMsgs.email}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <!-- <label oncopy="return false" oncut="return false" onpaste="return false" onselectstart="return false" class="capchImage">{{captchImage}}
                                                        <span (click)="generateCaptcha()" style="padding: 0 15px;"><i class="fas fa-sync-alt"></i></span>
                                                    </label> -->
                                                    <input type="text" class="form-control" placeholder="Enter Authendication Code" formControlName="authCode">
                                                    <!-- <div *ngIf=" submitted && f.captch.errors" class="invalid-feedback">
                                                        <div *ngIf=" submitted && f.captch.errors.required">Captcha {{errorMsgs.required}}</div>
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div style="padding-bottom: 5px;" class="col-md-12">
                                                </div>
                                                <div class="col-md-12">
                                                    <button class="submitBtn globalBtn btn-block" type="button" [disabled]="!uidrCertForm.valid" (click)="submit()">Submit</button>
                                                </div>
                                                <!-- <div class="col-md-12" style="padding-top: 5px;text-align: center;font-size: 15px;">
                                                    <p><a routerLink="../login">Login</a> </p>
                                                </div> -->
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>